/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ speakerName: NonNullable<unknown> }} Speakers_Add_Speaker_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Add {speakerName} as speaker" |
*
* @param {Speakers_Add_Speaker_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_add_speaker_aria_label = /** @type {((inputs: Speakers_Add_Speaker_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Add_Speaker_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ajouter ${i?.speakerName} en tant qu'intervenant`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Füge ${i?.speakerName} als Lautsprecher hinzu`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Aggiungi ${i?.speakerName} come relatore`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Добавить ${i?.speakerName} в качестве динамика`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Añadir ${i?.speakerName} como orador`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`添加 ${i?.speakerName} 为扬声器`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.speakerName} をスピーカーとして追加`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.speakerName} को स्पीकर के रूप में जोड़ें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Adicione ${i?.speakerName} como alto-falante`)
	return /** @type {LocalizedString} */ (`Add ${i?.speakerName} as speaker`)
});